import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';

/** Wraps `/login`, `/register`, `/forgot-password`, `/reset-password` — redirects an already
 *  signed-in user straight into the app instead of showing the login form again. */
export function GuestOnly() {
  const status = useAppSelector((state) => state.auth.status);

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
